export const isFile = (entity) => 'File' in window && entity instanceof File
